import React from 'react'
import FaClose from 'react-icons/lib/fa/close'
import { any } from 'prop-types'
import styles from './TableDay.styl'

export default class InfoBox extends React.Component {

	static propTypes = {
		serie: any,
		maxBPM: any,
		recoveryBPM: any,
		close: any
	}

	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}

	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	render() {
		const { serie, maxBPM, recoveryBPM, close } = this.props
		return (
			<section className={ styles.popup }>
				<div className={ styles.message }>
					<i onClick={ close }><FaClose /></i>
					<div className={ styles.message_container }>
						<p>{ serie.repetitions } x ({ serie.accelerationTime } + { serie.time } + { serie.recoveryTime })</p>
						<p className={ styles.align }><strong>{ serie.accelerationTime } min</strong> aceleração </p>
						<p className={ styles.align }><strong>{ serie.time } min</strong> forte a <strong>{ maxBPM } ppm</strong></p>
						<p className={ styles.align }><strong>{ serie.recoveryTime } min</strong> recuperação a <strong>{ recoveryBPM } ppm</strong></p>
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Table/InfoBox.js